import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class EpicHorizontalScroller extends Vue {
    public title: string = 'EpicHorizontalScroller';

    public cards: any = [];

    public scrollController = {
        autoScroll: false,
        scrolledLng: 0,
        directionLeft: true,
        autoLngPerTimeUnit: 10,
        timeInterval: 300,
    };

    @Prop({ default: undefined })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public async mounted() {
        // const content: any = this.$refs.content;
        // this.scrollController.autoScroll = true;
        // setInterval(() => {
        //     if (this.scrollController.autoScroll) {
        //         if (this.scrollController.directionLeft) {
        //             this.scrollTo(content, this.scrollController.autoLngPerTimeUnit, this.scrollController.timeInterval);
        //         } else {
        //             this.scrollTo(content, -this.scrollController.autoLngPerTimeUnit, this.scrollController.timeInterval);
        //         }
        //         this.scrollController.scrolledLng += this.scrollController.autoLngPerTimeUnit;
        //         if (this.scrollController.scrolledLng >= content.scrollWidth) {
        //             this.scrollController.scrolledLng = 0;
        //             this.scrollController.directionLeft = !this.scrollController.directionLeft;
        //         }
        //     }
        // }, this.scrollController.timeInterval);
    }

    public swipeLeft() {
        const content = this.$refs.content;
        this.scrollController.directionLeft = true;
        this.scrollTo(content, -500, 300);
    }

    public swipeRight() {
        const content = this.$refs.content;
        this.scrollController.directionLeft = false;
        this.scrollTo(content, 500, 300);
    }

    public scrollTo(element: any, scrollPixels: any, duration: any) {
        const scrollPos = element.scrollLeft;
        // Condition to check if scrolling is required
        if (!((scrollPos === 0 || scrollPixels > 0) && (element.clientWidth + scrollPos === element.scrollWidth || scrollPixels < 0))) {
            // Get the start timestamp
            const startTime =
                'now' in window.performance
                    ? performance.now()
                    : new Date().getTime();

            const scroll = (timestamp: any) => {
                const timeElapsed = timestamp - startTime;
                const progress = Math.min(timeElapsed / duration, 1);
                element.scrollLeft = scrollPos + scrollPixels * progress;
                if (timeElapsed < duration) {
                    window.requestAnimationFrame(scroll);
                } else {
                    return;
                }
            };
            window.requestAnimationFrame(scroll);
        }
    }
}
